module.exports = __webpack_public_path__ + "img/succes.5cd8d97c.png";